<template>
  <div v-if="security" class="security-info">
    <div class="status-company liner">
      <strong>Черные списки: </strong>
      <div class="status-content" 
        v-if="security.black_list || security.black_list_client ">В черном списке
      </div>
      <div class="status-content" v-else>В ЧС не значится</div>
    </div>

    <div class="security-data">
      <div class="security-base-information">
        <h3>Информация АТИ</h3>
        <div v-if="security.ati_is_end">
          <p>
            <strong>Статус АТИ:</strong>
             {{ security.ati_manager_status }}
          </p>
          <p v-if="security.ati_manager_comment">
            <strong>Комментарий:</strong>
             {{ security.ati_manager_comment }}
          </p>
        </div>
        <div v-else><p>Еще не проверен</p></div>
        
      </div>
    </div>

    <div class="status-company">
      
    </div>

  </div>
</template>

<script>
export default {
  name: 'ManagerSecurityInfo',
  props: ['security'],
};
</script>

<style scoped>
.security-info {

}

.security-data{
  display: flex;
  justify-content: space-evenly;

}

.security-base-information h3 {
  text-align: center;
}

.company-info h3 {
  font-size: 20px;
  font-weight: bold;
}

.company-info p {
  margin: 5px 0;
}

.company-info p:first-child {
  margin-top: 0;
}

.status-company{
  display: flex;
  justify-content: center;
  margin: 10px 0;
}

.status-content{
  margin-left: 10px;
  margin-bottom: 4px;
}

.security-base-information{
  display: flex;
  flex-direction: column;
  text-align: left;
  flex-grow:1
}
</style>
